<template>
	<VDialogV3
		id="vehicle-type-card"
		position="right"
		width="600px"
		height="100vh"
    :entity="localVehicleType"
		:loading="localVehicleType == null"
		:submit-disabled="isSaveDisabled"
		@submit-button:clicked="onSubmit"
	>
		<section>
      <VInput
        ref="nameInput"
        v-model="localVehicleType.name"
        label="Название"
        layout="vertical"
        required
        :max-length="200"
      />
		</section>

		<template #footer>
			<VButton
				theme="primary"
				@click="onSubmit"
			>
				Сохранить
			</VButton>

			<VButton
				v-show="editMode"
				@click="onDelete"
			>
				Удалить
			</VButton>
		</template>
	</VDialogV3>
</template>

<script lang="ts">

import VehicleType         from '@/domains/VehicleTypes/VehicleType';
import VehicleTypesService from '@/domains/VehicleTypes/VehicleTypesService';

export default defineComponent({
	name: 'VehicleTypeCard',

	props: {
		/** Готовый объект — передаётся из реестра */
		vehicleType: {
			type:    VehicleType,
			default: null,
		},
		/** ID — карточка сама загружает объект */
		id: {
			type:    Number,
			default: null,
		},
	},

	data() {
		return {
			localVehicleType: null as VehicleType | null,
		};
	},

	computed: {
		editMode(): boolean {
			return this.localVehicleType?.id != null;
		},

		isSaveDisabled(): boolean {
			return !this.localVehicleType?.name;
		},
	},

	async mounted() {
		await this.init();
	},

	methods: {
		async init(): Promise<void> {
			const id = this.id ?? this.vehicleType?.id;
      if (id) {
				this.localVehicleType = await VehicleTypesService.get(id);
			}
			else {
				this.localVehicleType = new VehicleType();
			}
		},

		async onSubmit(): Promise<void> {
			if (!this.localVehicleType) return;

			const success = this.editMode
				? await VehicleTypesService.update(this.localVehicleType)
				: await VehicleTypesService.add(this.localVehicleType);

      if (success) {
        this.$core.dialogs.VehicleTypeCard.resolve();
      }
		},

		async onDelete(): Promise<void> {
			if (!this.localVehicleType) return;

			const success = await VehicleTypesService.deleteWithConfirmation(this.localVehicleType);

      if (success) {
        this.$core.dialogs.VehicleTypeCard.resolve();
      }
		},
	},
});
</script>
